export default class ParallaxBlock {
    constructor(selector) {
        this._objects = document.querySelectorAll(selector);
        this.init();
    }

    init() {
        this._objects.forEach(_object => {
            ParallaxBlock.adjust(_object);
            window.addEventListener('scroll', () => {
                ParallaxBlock.adjust(_object);
            });
        });
    }

    static adjust(_object) {
        const box = _object.getBoundingClientRect();
        if (box.top < 0 && box.bottom < 0) {
            _object.style.backgroundPositionY = 'top';
        } else if (box.top > window.innerHeight && box.bottom > window.innerHeight) {
            _object.style.backgroundPositionY = 'bottom';
        } else {
            let espacio_superior = box.height - box.top;
            if(ParallaxBlock.getOffsets(_object).top === 0){
               espacio_superior -= box.height;
            }

            let espacio_inferior = box.height - box.bottom;


            let desplazamiento = (((espacio_superior + espacio_inferior) * 100 / (box.height + window.innerHeight)) + 100) / 2;
            _object.style.backgroundPositionY = (100 - desplazamiento) + '%';
        }
    }

    static getOffsets(_object){
        const rect = _object.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
                left: rect.left + document.body.scrollLeft
        }
    }

    static getScrollTop() {
        return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }
}



// WEBPACK FOOTER //
// ./js/parallax.js